import type React from 'react';

import BaseLibraryIconSvg from '@/components/Icon/BaseLibraryIconSvg';
import type { StarInterface } from '@/components/StarRatingComponent/Star';

const StarFilled: React.FC<StarInterface> = ({
  viewBox,
  width,
  isOnDark,
  color,
}) => {
  return (
    <BaseLibraryIconSvg
      name={`star-filled-${isOnDark ? 'dark' : 'light'}`}
      width={width}
      color={color}
      viewBox={viewBox}
    >
      <g clipPath='url(#clip0_6642_65892)'>
        {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
        <mask
          id='mask0_6642_65892'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width={width}
          height={width}
        >
          <path d='M32 0H0V32H32V0Z' fill='white' />
        </mask>
        <g mask='url(#mask0_6642_65892)'>
          <path
            d='M16 26.4398L7.4878 31.8376C7.23831 31.967 7.00687 32.0191 6.79349 31.9938C6.58006 31.9686 6.37266 31.8913 6.17127 31.7618C5.96992 31.6324 5.81663 31.4469 5.7114 31.2054C5.60621 30.964 5.59721 30.7028 5.68438 30.4218L7.94766 20.3033L0.458935 13.4803C0.24852 13.3004 0.109494 13.0849 0.0418559 12.834C-0.0257427 12.583 -0.0114609 12.3424 0.084701 12.1119C0.180902 11.8815 0.31016 11.6937 0.472474 11.5485C0.63475 11.4033 0.854153 11.3054 1.13068 11.2549L11.0135 10.3505L14.8683 0.767082C14.9736 0.495589 15.1261 0.299868 15.326 0.17992C15.5258 0.0599723 15.7505 0 16 0C16.2495 0 16.4742 0.0599723 16.674 0.17992C16.8739 0.299868 17.0264 0.495589 17.1317 0.767082L20.9865 10.3505L30.8693 11.2549C31.1458 11.3054 31.3652 11.4033 31.5275 11.5485C31.6898 11.6937 31.8191 11.8815 31.9153 12.1119C32.0115 12.3424 32.0257 12.583 31.9581 12.834C31.8905 13.0849 31.7515 13.3004 31.5411 13.4803L24.0523 20.3033L26.3156 30.4218C26.4028 30.7028 26.3938 30.964 26.2886 31.2054C26.1834 31.4469 26.0301 31.6324 25.8287 31.7618C25.6273 31.8913 25.4199 31.9686 25.2065 31.9938C24.9931 32.0191 24.7617 31.967 24.5122 31.8376L16 26.4398Z'
            fill={color}
          />
        </g>
      </g>
      <defs>
        {/** biome-ignore lint/correctness/useUniqueElementIds: Automated migration to Biome */}
        <clipPath id='clip0_6642_65892'>
          <rect width={width} height={width} fill='white' />
        </clipPath>
      </defs>
    </BaseLibraryIconSvg>
  );
};

export default StarFilled;
